import { render } from "./ChangePlanDialog.vue?vue&type=template&id=23639d43&scoped=true"
import script from "./ChangePlanDialog.vue?vue&type=script&lang=ts"
export * from "./ChangePlanDialog.vue?vue&type=script&lang=ts"

import "./ChangePlanDialog.vue?vue&type=style&index=0&id=23639d43&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23639d43"

export default script